import React from 'react';
import { Form, Input, DatePicker, Button, Tooltip, message } from 'antd';
import moment from 'moment';
import Modal from '../../../../../../components/Modal/Modal';
import { MSG_ERROR } from '../../../../../../constants';
import { getApiErrorMessage } from '../../../../../../utils/httpError';

const FormItem = Form.Item;

function StartSubmissionForm({ form, loading, onCancel, onSubmit }) {
  const { getFieldDecorator, validateFields } = form;

  const handleOk = () => {
    validateFields(async (err, values) => {
      if (err) return;
      try {
        const dateValue = values.questionnaireDate;
        await onSubmit({
          participant: values.participant.trim(),
          // antd@3 DatePicker returns a moment instance
          questionnaireDate: dateValue && dateValue.toISOString ? dateValue.toISOString() : moment().toISOString(),
        });
      } catch (error) {
        message.error(getApiErrorMessage(error, MSG_ERROR));
      }
    });
  };

  return (
    <Form layout="vertical" className="testing-exercising-start-form">
      <FormItem label="Participant / facilitator">
        {getFieldDecorator('participant', {
          rules: [{ required: true, whitespace: true, message: 'Please enter a participant name.' }],
        })(<Input placeholder="e.g. Crisis Management Team" disabled={loading} />)}
      </FormItem>
      <FormItem label="Exercise date">
        {getFieldDecorator('questionnaireDate', {
          initialValue: moment(),
          rules: [{ required: true, message: 'Please select a date.' }],
        })(<DatePicker style={{ width: '100%' }} disabled={loading} />)}
      </FormItem>
      <div className="testing-exercising-start-actions">
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button type="primary" loading={loading} onClick={handleOk}>
          Start walkthrough
        </Button>
      </div>
    </Form>
  );
}

const WrappedStartForm = Form.create()(StartSubmissionForm);

export default function StartSubmissionModal({
  triggerLabel = 'Start walkthrough',
  loading,
  onStart,
  disabled = false,
  disabledReason,
}) {
  return (
    <Modal
      title="Start scenario walkthrough"
      toggle={(show) =>
        disabled ? (
          <Tooltip title={disabledReason}>
            <span className="testing-exercising-hub__start-disabled">
              <Button type="primary" icon="play-circle" disabled>
                {triggerLabel}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button type="primary" icon="play-circle" onClick={show} loading={loading}>
            {triggerLabel}
          </Button>
        )
      }
    >
      {(hide) => (
        <WrappedStartForm
          loading={loading}
          onCancel={hide}
          onSubmit={async (values) => {
            await onStart(values);
            hide();
          }}
        />
      )}
    </Modal>
  );
}
